import React from "react";
import "./common.css";
import CustomInput from "./CustomInput";

class InputCard extends React.Component {
  state = {};
  constructor() {
    super();
    this.changes = {};
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.jsonObj !== prevState.layout) {
      return { layout: nextProps.jsonObj }; // <- this is setState equivalent
    } else {
      return null;
    }
  }
  getInputNewData = (property, value) => {
    this.changes[property] = value;
    this.props.setCardsInfo(this.changes, this.state.layout.title);
  };
  renderInputs = () => {
    if (this.state.layout !== undefined) {
      const item = this.state.layout.items.map((item, key) => {
        if (this.state[item.item.intemName] !== item) {
          this.setState({ [item.item.intemName]: item });
        }
        return (
          <CustomInput
            key={key}
            item={item}
            minWidth={item.size ? item.size : "50%"}
            size={item.size}
            handleNewData={this.getInputNewData}
            functions={this.props.functions}
          />
        );
      });
      return item;
    }
  };
  componentDidMount = () => {
  };
  render() {
    return (
      <div
        className="custom-card"
        style={{ flex: this.props.flex ? this.props.flex : "unset" }}
      >
        {this.state.layout &&
        !this.state.layout.hideTitle &&
        this.state.layout.title ? (
          <h4 className="title">{this.state.layout.title}</h4>
        ) : null}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: this.props.justifyContent
              ? this.props.justifyContent
              : "flex-end",
            flex: 1
          }}
        >
          {this.renderInputs()}
        </div>
      </div>
    );
  }
}

export default InputCard;
